import React, { useState, useEffect} from 'react';
import axios from "axios";
import FloatingLabel from 'react-bootstrap/FloatingLabel';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { enquirysubmit } from './Api_list';
let color = {};
const Contact_form = () => {
  
        const [name, setName] = useState("");
        const [mobileNumber, setMobileNumber] = useState("");
        const [emailid, setEmailid] = useState("");
        const [messageData, setMessageData] = useState("");
        const [message, setMessage] = useState("");
       
      let handleSubmit = async (e) => {
        e.preventDefault();
        const post = {
          full_name     : name,
          email_id      : setEmailid, 
          looking_for   : "",
          type          : 'contact_us',
          message_data  : messageData,
          mobile_no     : mobileNumber,
        } 
      if((name.length != 0) && (mobileNumber.length === 10)){
        try {
          var headerData = {"headers":{
            "Accept": "application/json",
            "Content-Type": "application/json", 
            "authorization": window.HEADERSAUTH,
          }} 
          const res = await axios.post(enquirysubmit, post, headerData)
          if (res.status === 200) {
            color.color = 'white';
            setName("");setMobileNumber("");setMessageData("");setEmailid("");
                setMessage('Thank you, your call back request has been submitted successfully!');
                setTimeout(() => {
                  setMessage('');
                }, 5000);
              } else {
                color.color = 'red';
                setMessage("Some error occured");
                setTimeout(() => {
                  setMessage('');
                }, 5000);
              }
        } catch (e) {
          color.color = 'red';
          setMessage("Some error occured");
          setTimeout(() => {
            setMessage('');
          }, 5000);
        }
      }else{
        color.color = 'red';
        setMessage("Please enter valid mobile number"); 
        setTimeout(() => {
          setMessage('');
        }, 5000);
      }
      };
 
    return ( 
        <>
            <div className='contfrm_wrp'>
            <div className="message">{message ? <p style={color}>{message}</p> : null}</div> 
                <h3 className='form_hdng text-left'>Send your query</h3>
                <Form className='row' onSubmit={handleSubmit}>
                    
                    <Col className="mb-3 col-sm-6">
                        <FloatingLabel controlId="floatingInputGrid" label="Full Name">
                            <Form.Control type="text" onChange={(e) => setName(e.target.value)} value={name} placeholder="Full Name" />
                        </FloatingLabel>
                    </Col>
                    <Col className="mb-3 col-sm-6">
                        <FloatingLabel controlId="floatingInputGrid" label="Contact Number">
                            <Form.Control type="text" onChange={(e) => setMobileNumber(e.target.value)} value={mobileNumber} maxLength={10} placeholder="Contact Number" />
                        </FloatingLabel>
                    </Col>
 
                    <Col className="mb-3 col-sm-12">
                        <FloatingLabel controlId="floatingInputGrid" label="Email address">
                            <Form.Control type="email" onChange={(e) => setEmailid(e.target.value)} value={emailid} placeholder="name@example.com" />
                        </FloatingLabel>
                    </Col>
                    <Col className='col-sm-12 mb-3'>
                        <FloatingLabel controlId="floatingTextarea2" label="Comments">
                            <Form.Control
                            onChange={(e) => setMessageData(e.target.value)} value={messageData}
                                as="textarea"
                                placeholder="Message"
                                style={{ height: '100px' }}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col className="mb-3 col-sm-12">
                    <Button variant="primary" type="submit">
                        Apply Now
                    </Button>
                    </Col>
                </Form>
            </div>
        </>
    );
}

export default Contact_form;